import { styled, Tooltip } from "@mui/material";

const TooltipLight = styled(({ className, backgroundColor, variant, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ backgroundColor = "white", variant, maxWidth }) => {
  const tooltipStyles = {
    backgroundColor,
    color: "rgba(0, 0, 0, 0.87)",
    margin: 4,
    padding: "4 8",
    border: variant === "outline" ? "1px solid #bbb" : "none",
    boxShadow: variant === "outline" ? "none" : "0px 0px 8px #00000034",
  };

  if (maxWidth) tooltipStyles.maxWidth = maxWidth;

  return {
    [`& .MuiTooltip-tooltip`]: tooltipStyles,
    [`& .MuiTooltip-arrow`]: {
      color: "rgba(0, 0, 0, 0.87)",
      "&::before": {
        backgroundColor,
        border: variant === "outline" ? "1px solid #bbb" : "none",
        boxShadow: variant === "outline" ? "none" : "0px 0px 2px #00000034",
      },
    },
  };
});

export default TooltipLight;
